module.exports = __webpack_public_path__ + "img/Professor_Desktop@2x.bab52d8.webp";